export default __webpack_public_path__ + "static/media/rice.c6d0bec5.png";